const setting = () => {
  return <>
    <div className="title" >
      setting change according to your need
    </div>
    <div className="content">

      <p>Currently, this page is under development. Please check back later for updates.</p>
      <p>In the meantime, you can explore other sections of the application.</p>
    </div>;
  </>

}
export default setting;